var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "pa-2", attrs: { flat: "" } },
    [
      _c(
        "div",
        {
          staticClass: "mb-2",
          style: "height: " + (_vm.mapHeight - _vm.computedOffsetTop) + "px",
        },
        [
          _c(
            "LMap",
            {
              staticStyle: { height: "100%", width: "100%", "z-index": "0" },
              attrs: {
                zoom: _vm.zoom,
                bounds: _vm.mapBounds,
                center: _vm.center,
                options: { zoomControl: false, attributionControl: false },
              },
            },
            [
              _vm._l(_vm.tileProviders, function (tile) {
                return _c("LTileLayer", {
                  key: tile.name,
                  attrs: {
                    name: tile.name,
                    visible: tile.visible,
                    url: tile.url,
                    attribution: tile.attribution,
                    "layer-type": "base",
                  },
                })
              }),
              _c("LControlZoom", { attrs: { position: "topright" } }),
              _c("LControlLayers", { attrs: { position: "topright" } }),
              _c(
                "LControl",
                { attrs: { position: "topright" } },
                [
                  _c("v-menu", {
                    attrs: {
                      "open-on-hover": "",
                      "close-on-content-click": false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function (ref) {
                          var on = ref.on
                          return [
                            _c(
                              "v-card",
                              _vm._g({ attrs: { flat: "" } }, on),
                              [
                                _c(
                                  "v-icon",
                                  { staticClass: "ma-1", attrs: { large: "" } },
                                  [_vm._v("settings")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function () {
                          return [
                            _c(
                              "v-list",
                              [
                                _c("v-switch", {
                                  staticClass: "mx-1",
                                  attrs: {
                                    dense: "",
                                    label: "Cluster elements",
                                  },
                                  model: {
                                    value: _vm.clusterElements,
                                    callback: function ($$v) {
                                      _vm.clusterElements = $$v
                                    },
                                    expression: "clusterElements",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "LControl",
                { attrs: { position: "topleft" } },
                [
                  _c(
                    "v-card",
                    [_c("v-card-text", [_vm._v(_vm._s(this.caseName))])],
                    1
                  ),
                ],
                1
              ),
              _c(
                "LControl",
                {
                  staticClass: "logo-control",
                  attrs: { position: "bottomright" },
                },
                [
                  _c("img", {
                    staticClass: "logo",
                    attrs: {
                      src: require("@/assets/rex-logo.png"),
                      alt: "Acelerex",
                    },
                  }),
                ]
              ),
              _vm.showHeatmap
                ? _c(
                    "LControl",
                    {
                      staticClass: "heatmap-control",
                      attrs: { position: "bottomright" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          attrs: { width: "128", outlined: "", elevation: "0" },
                        },
                        [
                          _c(
                            "v-row",
                            { staticClass: "no-gutters" },
                            [
                              _c(
                                "v-card",
                                { staticClass: "grow", attrs: { flat: "" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "my-0 text-caption font-weight-medium text-center",
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.camelToTitleCase(
                                              _vm.heatmapMeasure
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                  _vm.heatmapUnit
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "my-0 pl-1 text-caption font-weight-medium text-center",
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(_vm.heatmapUnit) + " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._l(_vm.heatmapScale, function (color) {
                            return _c(
                              "v-row",
                              { key: color.code, staticClass: "no-gutters" },
                              [
                                _c(
                                  "v-card",
                                  {
                                    staticClass: "d-flex grow pa-1",
                                    attrs: { flat: "" },
                                  },
                                  [
                                    _c("p", { staticClass: "mb-0 ml-1" }, [
                                      _vm._v(_vm._s(color.range)),
                                    ]),
                                    _c("v-spacer"),
                                    _c("v-card", {
                                      attrs: {
                                        color: color.code,
                                        height: "16",
                                        width: "16",
                                        flat: "",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "LLayerGroup",
                { attrs: { name: "Nodes", "layer-type": "overlay" } },
                [
                  _vm.nodes.length
                    ? _vm._l(_vm.nodes, function (node) {
                        return _c(
                          "LMarker",
                          {
                            key: node.id,
                            attrs: {
                              "lat-lng": node.coordinates,
                              icon: _vm.nodeIcon,
                            },
                          },
                          [
                            _c("LPopup", [
                              _c("div", [
                                _vm._v(
                                  " " +
                                    _vm._s(node.id + " - " + node.name) +
                                    " "
                                ),
                              ]),
                            ]),
                          ],
                          1
                        )
                      })
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "LLayerGroup",
                { attrs: { name: "Branches", "layer-type": "overlay" } },
                [
                  _vm.branches
                    ? _vm._l(_vm.branches, function (branch, i) {
                        return _c("LPolyline", {
                          key: i,
                          attrs: {
                            "lat-lngs": _vm.branchPoints(branch),
                            color: "black",
                          },
                        })
                      })
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "LLayerGroup",
                { attrs: { name: "Projects", "layer-type": "overlay" } },
                [
                  _vm.projects.length
                    ? [
                        _c(
                          "VMarkerCluster",
                          {
                            key: "cluster-" + _vm.clusterKey,
                            ref: "clusterRef",
                            attrs: { options: _vm.clusterOptions },
                          },
                          _vm._l(_vm.projects, function (project, i) {
                            return _c(
                              "LMarker",
                              {
                                key: i,
                                attrs: {
                                  "lat-lng": project.coordinates,
                                  icon: _vm.getIcon(
                                    project.iconType,
                                    project.color
                                  ),
                                },
                                on: {
                                  "update:latLng": function ($event) {
                                    return _vm.projectUpdate($event, project)
                                  },
                                },
                              },
                              [
                                _c(
                                  "LPopup",
                                  { attrs: { options: { offset: [0, -24] } } },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c(
                                          "v-card",
                                          { attrs: { flat: "", width: "240" } },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-subtitle-1 my-1",
                                              },
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    attrs: {
                                                      to: {
                                                        path:
                                                          "/case/" +
                                                          _vm.caseId +
                                                          "/input#Project",
                                                        query: {
                                                          projectName:
                                                            project.name,
                                                        },
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(i + " ") +
                                                        " " +
                                                        _vm._s(project.name) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _vm.showHeatmap
                                              ? _c(
                                                  "p",
                                                  { staticClass: "my-0" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.outputValue(
                                                            project.name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                          1
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "LLayerGroup",
                {
                  attrs: { name: "Opportunity Zones", "layer-type": "overlay" },
                },
                _vm._l(_vm.computedOpportunityZones, function (zone) {
                  return _c("LPolygon", {
                    key: zone.id,
                    attrs: {
                      "lat-lngs": zone.latLng,
                      stroke: false,
                      "fill-color": "#E65100",
                      "fill-opacity": 0.5,
                    },
                  })
                }),
                1
              ),
              _vm.showHeatmap
                ? _c(
                    "LLayerGroup",
                    { attrs: { name: "Heatmap", "layer-type": "overlay" } },
                    [
                      _c("LInterpolation", {
                        ref: "idwComponent",
                        attrs: {
                          "lat-lng": _vm.heatMapLatLng,
                          bounds: _vm.heatmapBounds,
                          cellSize: _vm.heatmapCellSize,
                          discrete: "",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._l(_vm.mapLayers, function (layer) {
                return _c(
                  "LLayerGroup",
                  {
                    key: layer.id,
                    attrs: {
                      name: layer.name,
                      "layer-type": "overlay",
                      visible: false,
                    },
                  },
                  [
                    _vm._l(_vm.layerFeatures(layer), function (feature) {
                      return [
                        feature.geomType === "point"
                          ? _c(
                              "LCircleMarker",
                              {
                                key: feature.featureId,
                                attrs: {
                                  "lat-lng": [feature.lat, feature.lon],
                                  radius: _vm.layerRadius(layer, feature.value),
                                  color: _vm.strokeColor(layer, feature),
                                  "fill-color": _vm.fillColor(layer, feature),
                                  "fill-opacity": 0.85,
                                  weight: 2,
                                  "dash-array":
                                    feature.style === "dashed" ? "3,3" : null,
                                },
                              },
                              [
                                _c(
                                  "LPopup",
                                  { attrs: { options: { offset: [0, -4] } } },
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "", width: "220" } },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-subtitle-2 mb-1",
                                          },
                                          [_vm._v(_vm._s(feature.name))]
                                        ),
                                        feature.owner
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.owner))]
                                            )
                                          : _vm._e(),
                                        feature.location
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.location))]
                                            )
                                          : _vm._e(),
                                        feature.status
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.status))]
                                            )
                                          : _vm._e(),
                                        feature.value != null
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      feature.valueLabel ||
                                                        (layer.valueDomain &&
                                                          layer.valueDomain
                                                            .label)
                                                    ) +
                                                    ": " +
                                                    _vm._s(feature.value) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        feature.date
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.date))]
                                            )
                                          : _vm._e(),
                                        feature.notes
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.notes))]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c(
                              "LPolyline",
                              {
                                key: feature.featureId,
                                attrs: {
                                  "lat-lngs": feature.points,
                                  color: _vm.fillColor(layer, feature),
                                  weight: 2.4,
                                  "dash-array":
                                    feature.style === "dashed" ? "8,6" : null,
                                },
                              },
                              [
                                _c(
                                  "LPopup",
                                  [
                                    _c(
                                      "v-card",
                                      { attrs: { flat: "", width: "220" } },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-subtitle-2 mb-1",
                                          },
                                          [_vm._v(_vm._s(feature.name))]
                                        ),
                                        feature.owner
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.owner))]
                                            )
                                          : _vm._e(),
                                        feature.status
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.status))]
                                            )
                                          : _vm._e(),
                                        feature.value != null
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      feature.valueLabel ||
                                                        (layer.valueDomain &&
                                                          layer.valueDomain
                                                            .label)
                                                    ) +
                                                    ": " +
                                                    _vm._s(feature.value) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        feature.notes
                                          ? _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "my-0 text-caption",
                                              },
                                              [_vm._v(_vm._s(feature.notes))]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                      ]
                    }),
                  ],
                  2
                )
              }),
              _vm.mapLayers.length
                ? _c(
                    "LControl",
                    { attrs: { position: "bottomleft" } },
                    [
                      _c("MapLayerLegendPanel", {
                        attrs: { layers: _vm.mapLayers },
                        model: {
                          value: _vm.mapLayerFilters,
                          callback: function ($$v) {
                            _vm.mapLayerFilters = $$v
                          },
                          expression: "mapLayerFilters",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm.hasOutputs
        ? _c(
            "v-toolbar",
            [
              [
                _c(
                  "v-col",
                  { staticClass: "mt-4", attrs: { sm: "2", cols: "2" } },
                  [
                    _c("v-checkbox", {
                      attrs: {
                        label: "Heatmap",
                        dense: "",
                        disabled: !_vm.hasOutputs,
                      },
                      model: {
                        value: _vm.showHeatmap,
                        callback: function ($$v) {
                          _vm.showHeatmap = $$v
                        },
                        expression: "showHeatmap",
                      },
                    }),
                  ],
                  1
                ),
                _c("v-spacer"),
                _c(
                  "v-col",
                  { staticClass: "mt-5", attrs: { sm: "2", cols: "2" } },
                  [
                    _c("v-select", {
                      attrs: {
                        label: "Year",
                        items: _vm.outputYears,
                        dense: "",
                        "menu-props": "top offset-y",
                      },
                      model: {
                        value: _vm.heatmapYear,
                        callback: function ($$v) {
                          _vm.heatmapYear = $$v
                        },
                        expression: "heatmapYear",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "mt-5", attrs: { sm: "2", cols: "2" } },
                  [
                    _c("v-select", {
                      attrs: {
                        label: "Asset",
                        items: _vm.availableAssetsItems,
                        dense: "",
                        "menu-props": "top offset-y",
                      },
                      model: {
                        value: _vm.heatmapAsset,
                        callback: function ($$v) {
                          _vm.heatmapAsset = $$v
                        },
                        expression: "heatmapAsset",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "mt-5", attrs: { sm: "3", cols: "2" } },
                  [
                    _c("v-select", {
                      attrs: {
                        label: "Measure",
                        items: _vm.measures,
                        dense: "",
                        "menu-props": "top offset-y",
                      },
                      model: {
                        value: _vm.heatmapMeasure,
                        callback: function ($$v) {
                          _vm.heatmapMeasure = $$v
                        },
                        expression: "heatmapMeasure",
                      },
                    }),
                  ],
                  1
                ),
                _c("v-spacer"),
                _vm.showHeatmap
                  ? _c(
                      "v-menu",
                      {
                        attrs: {
                          top: "",
                          left: "",
                          "offset-y": "",
                          "close-on-content-click": false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function (ref) {
                                var menuOn = ref.on
                                return [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function (ref) {
                                              var tooltipOn = ref.on
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        medium: "",
                                                      },
                                                    },
                                                    Object.assign(
                                                      {},
                                                      tooltipOn,
                                                      menuOn
                                                    )
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color: "primary",
                                                        },
                                                      },
                                                      [_vm._v("settings")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Settings")])]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2365902927
                        ),
                      },
                      [
                        _c(
                          "v-card",
                          { attrs: { width: "200" } },
                          [
                            _c(
                              "v-card-text",
                              [
                                _c(
                                  "span",
                                  { staticClass: "mb-2 text-subtitle-2" },
                                  [_vm._v("Scale Limits")]
                                ),
                                _c(
                                  "v-radio-group",
                                  {
                                    staticClass: "my-0",
                                    attrs: { dense: "" },
                                    model: {
                                      value: _vm.scaleOption,
                                      callback: function ($$v) {
                                        _vm.scaleOption = $$v
                                      },
                                      expression: "scaleOption",
                                    },
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: { value: "auto", label: "Auto" },
                                    }),
                                    _c("v-radio", {
                                      attrs: {
                                        value: "custom",
                                        label: "Custom",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Max.",
                                    type: "number",
                                    minumum: _vm.scaleCustomMin + 1,
                                    disabled: _vm.scaleOption === "auto",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.scaleCustomMax,
                                    callback: function ($$v) {
                                      _vm.scaleCustomMax = _vm._n($$v)
                                    },
                                    expression: "scaleCustomMax",
                                  },
                                }),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "Min.",
                                    type: "number",
                                    maximum: _vm.scaleCustomMax - 2,
                                    disabled: _vm.scaleOption === "auto",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.scaleCustomMin,
                                    callback: function ($$v) {
                                      _vm.scaleCustomMin = _vm._n($$v)
                                    },
                                    expression: "scaleCustomMin",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "mb-2 text-subtitle-2" },
                                  [_vm._v("Resolution")]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    label: "",
                                    type: "number",
                                    min: 5,
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.heatmapCellSize,
                                    callback: function ($$v) {
                                      _vm.heatmapCellSize = _vm._n($$v)
                                    },
                                    expression: "heatmapCellSize",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
            ],
            2
          )
        : _vm._e(),
      _c(
        "v-toolbar",
        { staticClass: "mt-2" },
        [
          _c("v-col", { staticClass: "mt-4", attrs: { sm: "2" } }, [
            _c(
              "p",
              [
                _vm._v(" Opportunity Zones "),
                _vm.isFindOpportunityZonesPending || _vm.isBatchPending
                  ? _c("v-progress-circular", {
                      staticClass: "ml-2",
                      attrs: {
                        indeterminate: "",
                        color: "secondary",
                        size: "24",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
          _c(
            "v-col",
            { staticClass: "mt-4" },
            [
              _c("v-select", {
                staticClass: "ml-8",
                attrs: {
                  label: "States",
                  items: _vm.states,
                  "item-text": "stateName",
                  multiple: "",
                  "return-object": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "selection",
                    fn: function (ref) {
                      var item = ref.item
                      var index = ref.index
                      return [
                        index < 5
                          ? _c("v-chip", { attrs: { small: "" } }, [
                              _c("span", [_vm._v(_vm._s(item.stateName))]),
                            ])
                          : _vm._e(),
                        index == 5
                          ? _c(
                              "span",
                              { staticClass: "grey--text text-caption" },
                              [
                                _vm._v(
                                  " (+" +
                                    _vm._s(_vm.selectedStates.length - 5) +
                                    " others) "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
                model: {
                  value: _vm.selectedStates,
                  callback: function ($$v) {
                    _vm.selectedStates = $$v
                  },
                  expression: "selectedStates",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-expansion-panels",
        { staticClass: "mt-2", attrs: { tile: "" } },
        [
          _c(
            "v-expansion-panel",
            [
              _c("v-expansion-panel-header", [
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(" Custom Map Layers "),
                  _c("span", { staticClass: "grey--text text-caption ml-2" }, [
                    _vm._v("(" + _vm._s(_vm.mapLayers.length) + ")"),
                  ]),
                ]),
              ]),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-list",
                    { attrs: { dense: "" } },
                    [
                      !_vm.mapLayers.length
                        ? _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-title",
                                { staticClass: "text-caption grey--text" },
                                [_vm._v("No layers added")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.mapLayers, function (layer) {
                        return _c(
                          "v-list-item",
                          { key: layer.id },
                          [
                            _c(
                              "v-list-item-content",
                              [
                                _vm.renamingLayerId === layer.id
                                  ? _c("v-text-field", {
                                      attrs: {
                                        dense: "",
                                        "hide-details": "",
                                        autofocus: "",
                                      },
                                      on: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.confirmRename(layer)
                                        },
                                        blur: function ($event) {
                                          return _vm.confirmRename(layer)
                                        },
                                      },
                                      model: {
                                        value: _vm.renameValue,
                                        callback: function ($$v) {
                                          _vm.renameValue = $$v
                                        },
                                        expression: "renameValue",
                                      },
                                    })
                                  : _c("v-list-item-title", [
                                      _vm._v(_vm._s(layer.name)),
                                    ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-action",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.startRename(layer)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-pencil"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-action",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", small: "" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeMapLayer(layer.id)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      { attrs: { small: "", color: "error" } },
                                      [_vm._v("mdi-delete")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm.mapLayers.length ? _c("v-divider") : _vm._e(),
                      _c(
                        "v-list-item",
                        [
                          _c("MapLayerUpload", {
                            on: { "add-layer": _vm.addMapLayer },
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }